import { render, staticRenderFns } from "./textarea-field.vue?vue&type=template&id=2e0868d4"
import script from "./textarea-field.vue?vue&type=script&lang=ts"
export * from "./textarea-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports